@if (industries) {
  <form [formGroup]="form" (validSubmit)="search()">
    <div class="modal-header">
      <h3 class="visually-hidden" id="modal-basic-title">
        Find the
        <app-tax-office-abbr [regimeId]="regimeId"></app-tax-office-abbr>
        Life/Rate
      </h3>

      <div class="input-group">
        <select
          data-dd-action-name="depreciation-lookup-modal.industry-select"
          class="form-select"
          formControlName="industry"
          aria-label="Industry"
        >
          <option [ngValue]="null">(Any Industry)</option>
          @for (industry of industries; track industry) {
            @if (industry.children) {
              <optgroup [label]="industry.name">
                <!-- prettier-ignore -->
                <option [ngValue]="industry.value">{{ industry.name }} - All</option>
                <!-- prettier-ignore -->
                @for (child of industry.children; track child) {
<option
             
              [ngValue]="child.value"
            >{{ child.name }}</option>
}
              </optgroup>
            } @else {
              <option [ngValue]="industry.value">{{ industry.name }}</option>
            }
          }
        </select>
        <input
          data-dd-action-name="depreciation-lookup-modal.search-input"
          type="search"
          class="form-control w-25"
          formControlName="search"
        />

        <button
          data-dd-action-name="depreciation-lookup-modal.search-button"
          type="submit"
          class="btn btn-primary"
        >
          Search
        </button>
      </div>

      <button
        data-dd-action-name="depreciation-lookup-modal.close-button"
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('exit')"
      ></button>
    </div>

    <div class="modal-body">
      @switch (status) {
        @case ('SEARCHING') {
          <div class="mb-3">
            <em>Searching&hellip;</em>
          </div>
        }
      }

      @if (results$ | async; as results) {
        @if (status === 'DONE') {
          @if (results.results.length === 0) {
            <div>
              <em>No results</em>
            </div>
          }

          @for (result of results.results; track result) {
            <app-depreciation-lookup-search-item
              [rates]="results.rates"
              [result]="result"
              (selectItem)="onSelect($event)"
            ></app-depreciation-lookup-search-item>
          }

          <div class="mb-4 text-center">
            @switch (results.status) {
              @case ('MORE') {
                <button
                  data-dd-action-name="depreciation-lookup-modal.load-more-button"
                  type="button"
                  class="btn btn-outline w-100"
                  (click)="results.next()"
                >
                  Load more&hellip;
                </button>
              }
              @case ('LOADING') {
                <em>Loading&hellip;</em>
              }
            }
          </div>
        }
      }
    </div>
  </form>
} @else {
  <app-loading></app-loading>
}
